import React, { FC, useMemo } from 'react'
import { Card, Title, Form, Input } from 'components/common'
import { useGeneralSettingQuery } from 'lib/graphql/storeadmin'

type Props = {
  baseTimeUnit?: number
  loading?: boolean
}

const ChargeUnit: FC<Props> = (props) => {
  const { baseTimeUnit, loading } = props

  const { data: generalSettingData, loading: generalSettingLoading } =
    useGeneralSettingQuery()

  const isSagaArena = useMemo(() => {
    if (!generalSettingData || generalSettingLoading) return
    return generalSettingData?.generalSetting?.domain === 'saga-arena'
  }, [generalSettingData, generalSettingLoading])

  const SAGA_ARENA_TEXT = (
    <>
      料金が発生する単位を設定できます。
      <br />
      メインアリーナとサブアリーナを除く施設はこの設定に基づいて利用料金が計算されます。
    </>
  )
  const OTHER_STORE_TEXT = (
    <>
      料金が発生する単位を設定できます。
      <br />
      この設定に基づいて利用料金が計算されます。
    </>
  )
  const explainText = isSagaArena ? SAGA_ARENA_TEXT : OTHER_STORE_TEXT

  return (
    <Card loading={loading}>
      <Title level={5}>料金発生単位</Title>
      <Form.Item
        name="baseTimeUnit"
        initialValue={baseTimeUnit ?? 180}
        rules={[
          {
            required: true,
            message: '料金発生単位は必須です',
          },
        ]}
      >
        <Input type="number" suffix="分" min={30} placeholder="180" />
      </Form.Item>
      <div className="opacity-60">{explainText}</div>
    </Card>
  )
}

export default ChargeUnit
